// extracted by mini-css-extract-plugin
export default {"left-half":"halfpage_left-half__HwgQH","right-half":"halfpage_right-half__0DMVa"};